import React, { useState, useEffect, useCallback } from "react";
import Layout, { Container } from "../components/layout";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { apiurl } from "../config/config";
import { useUser } from "../config/userProvider";
import SearchContainer from "../components/searchContainer";
import BackHeader from "../components/backHeader";
import Card from "../components/card";
import { ShadowContainer, CheckboxTable } from "../pages/addStore";
import { DynamicLoader } from "../components/loader";
import { MdErrorOutline } from "react-icons/md";
import { BlackButton } from "../components/buttonContainer";
import { toast } from "react-toastify";
import { AiOutlineDelete } from "react-icons/ai";
// import { IoMdArrowRoundBack } from "react-icons/io";
// import { FiSearch } from "react-icons/fi";

function StoreDetails() {
  const { storeId } = useParams();
  const navigate = useNavigate();
  const { userData } = useUser();
  let vendorObjId = userData?.vendorDetails?.vendorObjId;

  const [loading, setLoading] = useState(false);
  // const [managers, setManagers] = useState([]);
  const [selectedManager, setSelectedManager] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [deleteStoreLoading, setDeleteStoreLoading] = useState(false);
  const [storeDetails, setStoreDetails] = useState({
    // name: 'Ens Store',
    // email: 'ens.store@gmail.com',
    // phone: '9876543262',
    // address: 'tsgfads',
    // managerName: 'Shubham Sharma',
    // managerEmail: 'shubham.sharma@ens.enterprises',
    // managerPhone: '+1234567890',
  });
  console.log("storeDetails", storeDetails);
  const [formdata, setFormdata] = useState({
    manager: {},
    staff: [],
  });

  console.log("formdata", formdata);

  // =================== PAGINATION =================
  const [itemsPerPage, setItemsPerPage] = useState(50);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [paginationData, setPaginationData] = useState("");
  // const [deleteCustomerIds, setDeleteCustomerIds] = useState([]);
  // const [isDeleted, WantToDelete] = useState(false);

  // Calculate the current items to display
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const handlePageChange = (pageNumber) => {
  //   setCurrentPage(pageNumber);
  // };

  // =======================================================

  const [showAssignManagerPopup, setShowAssignManagerPopup] = useState(false);

  // const handleSelectUser = (user) => {
  //   // If the user is already selected, deselect it. Otherwise, set the selected user.
  //   setSelectedManager(selectedManager?._id === user._id ? null : user);
  // };

  const assignManagerPopup = () => {
    setShowAssignManagerPopup(!showAssignManagerPopup);
  };

  // const handleBack = () => {
  //   navigate("/stores");
  // };

  // const fetchUserData = async (vendorObjId) => {
  //   setLoading(true);
  //   let config = {
  //     method: "get",
  //     maxBodyLength: Infinity,
  //     url: `${apiurl}/admin/v1/store/get/${storeId}`,
  //     headers: {},
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log(JSON.stringify("response.data", response.data));
  //       if (response.data.success) {
  //         setStoreDetails(response.data?.store);
  //         setFormdata((prev) => ({
  //           ...prev,
  //           staff: response.data?.store?.staffDetails,
  //         }));
  //         setFormdata((prev) => ({
  //           ...prev,
  //           manager: response.data?.store?.managerDetails,
  //         }));
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  // useEffect(() => {
  //   // Make sure vendorObjId is provided before fetching the data
  //   if (userData?.vendorDetails?.vendorObjId) {
  //     fetchUserData(userData.vendorDetails.vendorObjId);
  //   }
  // }, [userData.vendorDetails.vendorObjId]); // Re-run when vendorObjId changes

  const fetchUserData = useCallback(
    async (vendorObjId) => {
      setLoading(true);

      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${apiurl}/admin/v1/store/get/${storeId}`,
        headers: {},
      };

      axios
        .request(config)
        .then((response) => {
          console.log("response.data", response.data);

          if (response.data.success) {
            setStoreDetails(response.data?.store);

            setFormdata((prev) => ({
              ...prev,
              staff: response.data?.store?.staffDetails,
              manager: response.data?.store?.managerDetails,
            }));
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [storeId],
  );

  useEffect(() => {
    if (userData?.vendorDetails?.vendorObjId) {
      fetchUserData(userData.vendorDetails.vendorObjId);
    }
  }, [userData?.vendorDetails?.vendorObjId, fetchUserData]);

  const editStoreDetails = (e) => {
    e.preventDefault();
    navigate(`/stores/${storeId}/edit`);
  };

  console.log("Store Details", storeDetails);
  const [showPopUp, setShowPopUp] = useState("");

  const [users, setUsers] = useState([]);

  const fetchUser = async () => {
    setLoading(true);
    let payload = JSON.stringify({
      vendorObjId: vendorObjId,
      // page: currentPage,
      page: 1,
      limit: JSON.parse(itemsPerPage),
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      // url: `${apiurl}/admin/v1/user/get`,
      url: `${apiurl}/admin/v1/user/get-unassigned-users`,
      // https://api-inficonnect.fixall.ai/admin/v1/user/get-unassigned-users

      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Customer Data:", response.data.data);
        // setAppData(response.data.data);
        // setLoading(false);
        setUsers(response?.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   fetchUser();
  // }, [itemsPerPage]);
  useEffect(() => {
    if (vendorObjId) {
      fetchUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsPerPage, vendorObjId]);
  // }, [currentPage, itemsPerPage]);

  // const [selectedManager, setSelectedManager] = useState("");
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [error, setError] = useState("asasd");
  const [assignLoader, setAssignLoader] = useState(false);
  const [deleteConfirmationPopup, setDeleteConfirmationPopup] = useState("");

  const ManagerSubmitHandler = () => {
    const manager = users.find((item) => item.id === selectedManager);
    AssignManagerHandler(manager);
  };
  console.log("selectedManager", selectedManager);

  const StaffSubmitHandler = () => {
    // if (!selectedStaff.length > 0) {
    const staff = users.filter((item) => selectedStaff.includes(item.id));
    AssignStaffHandler(staff);

    // }
  };

  const AssignManagerHandler = (manager) => {
    setAssignLoader(true);
    if (formdata?.manager) {
      let data = JSON.stringify({
        storeObjId: storeDetails?._id,
        managerEmail: manager?.email,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiurl}/admin/v1/store/assign-manager`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.data); // Inspect response structure
          if (response?.data?.success === true) {
            toast.success(
              response?.data?.message
                ? response.data.message
                : "Manager assigned successfully",
            );
            setFormdata((prev) => ({ ...prev, manager }));
            setShowPopUp("");
            setAssignLoader(false);
            // fetchUser();
            window.location.reload(); // Force a full reload of the page
          } else {
            setAssignLoader(false);
            toast.error(
              response?.data?.message
                ? response.data.message
                : "Failed to assign manager",
            );
            setError({
              type: "manager",
              message: response.data.message || "Something went wrong",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          setAssignLoader(false);
          setError({ type: "manager", message: error.response?.data?.message });
          toast.error("Failed to assign manager, Please try again later.");
        });
    }
  };

  const AssignStaffHandler = (staff) => {
    let data = JSON.stringify({
      storeObjId: storeDetails?._id,
      staffEmail: staff.map((staff) => staff.email),
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/store/assign-staff`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        if (response?.data?.success === true) {
          setFormdata((prev) => ({ ...prev, staff }));
          setShowPopUp("");
          toast.success(
            response?.data?.message
              ? response?.data?.message
              : "Staff assigned successfully",
          );
          // fetchUser();
          window.location.reload(); // Force a full reload of the page
        } else {
          toast.error(
            response?.data?.message
              ? response?.data?.message
              : "Failed to assign staff",
          );
          setError({ type: "staff", message: response.data.message });
        }
      })
      .catch((error) => {
        console.log(error);
        setError({ type: "staff", message: error.response?.data?.message });
        toast.error("Failed to assign staff, Please try again later.");
      });
  };

  const DeleteHandler = () => {
    setDeleteStoreLoading(true);

    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/store/delete/${storeId}`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        if (response.data.success) {
          toast.success(
            response.data.message
              ? response.data.message
              : "Store deleted successfully",
          );
          // WantToDelete(false);
          // fetchCustomerData(vendorObjId);
          handleDeleteConfirmationPopup();
          navigate("/stores");
          setDeleteStoreLoading(false);
          // setDeleteCustomerIds([]);
        } else {
          toast.error(
            response.data.message
              ? response.data.message
              : "Failed to delete store",
          );
          setDeleteStoreLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setDeleteStoreLoading(false);
      });
  };

  const handleDeleteConfirmationPopup = () => {
    setDeleteConfirmationPopup(!deleteConfirmationPopup);
  };

  const handleRemoveStaff = async (staffOid) => {
    try {
      const response = await fetch(`${apiurl}/admin/v1/store/removeStaff`, {
        method: "POST", // or 'DELETE' depending on your backend
        headers: {
          "Content-Type": "application/json",
          // Add auth header if needed, e.g.:
          // 'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          storeId: storeId, // you might want to get this dynamically
          staffOid: staffOid,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      if (response?.status === 200) {
        toast.success(response?.data?.message || "Staff removed successfully");
        fetchUserData(vendorObjId);
      } else {
        toast.error(
          response?.data?.message ||
            "Failed to remove staff. Please try again.",
        );
      }

      // Optional: Show success toast
      // toast.success("Staff removed successfully");
    } catch (error) {
      console.error("Failed to remove staff:", error);
      toast.error("Failed to remove staff. Please try again.");
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setError("");
    }, 5000);
  }, []);
  console.log("formdata.staff", formdata.staff);

  return (
    <Layout>
      <Container>
        {loading === true ? (
          <DynamicLoader maintext="wait" subtext="Fetching Store Data" />
        ) : (
          <>
            {showPopUp === "manager" ? (
              <Card.AddPopUp
                removePopUp={() => setShowPopUp("")}
                Background="bg-none"
                width="md:w-auto max-h-screen"
              >
                <ShadowContainer
                  ContainerClassName="mt-0"
                  isButton={false}
                  title="Assign Manager"
                  height="h-full"
                  margin="m-0"
                  rightSide={
                    <div>
                      {error && error?.type === "manager" && (
                        <div className=" flex items-center gap-2 bg-red-50 border border-red-300 text-red-600 text-sm px-3 rounded">
                          <MdErrorOutline /> {error?.message}
                        </div>
                      )}

                      {/* <span className="text-">
                        {" "}
                        - {paginationData?.totalItems}
                      </span> */}
                      <select
                        value={itemsPerPage}
                        className="text-xs rounded text-black border px-2 mx-2"
                        onChange={(e) => setItemsPerPage(e.target.value)}
                      >
                        {/* <option value="10">10</option> */}
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="250">250</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                      </select>
                    </div>
                  }
                >
                  <CheckboxTable
                    tableBody={users}
                    tableHead={["Manager Name", "Email", "Phone", "userType"]}
                    buttonTitle="Add Manager"
                    selected={selectedManager}
                    setSelected={setSelectedManager}
                    setShowPopUp={setShowPopUp}
                    handleSubmit={ManagerSubmitHandler}
                    height="h-full"
                    disable={assignLoader}
                    // disable={selectedManager === ""}
                  />
                </ShadowContainer>
              </Card.AddPopUp>
            ) : showPopUp === "staff" ? (
              <Card.AddPopUp
                removePopUp={() => setShowPopUp("")}
                Background="bg-none"
                width="md:w-auto"
              >
                <ShadowContainer
                  ContainerClassName="mt-0"
                  isButton={false}
                  title="Add Staff Member"
                  height="h-full"
                  margin="m-0"
                  rightSide={
                    <div>
                      {error && error?.type === "staff" && (
                        <div className=" flex items-center gap-2 bg-red-50 border border-red-300 text-red-600 text-sm px-3 rounded">
                          <MdErrorOutline /> {error?.message}
                        </div>
                      )}
                      <select
                        value={itemsPerPage}
                        className="text-xs rounded text-black border px-2 mx-2"
                        onChange={(e) => setItemsPerPage(e.target.value)}
                      >
                        {/* <option value="10">10</option> */}
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="250">250</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                      </select>
                    </div>
                  }
                >
                  <CheckboxTable
                    tableBody={users}
                    tableHead={["Manager Name", "Email", "Phone", "userType"]}
                    selected={selectedStaff}
                    setSelected={setSelectedStaff}
                    setShowPopUp={setShowPopUp}
                    isStaff={true}
                    buttonTitle="Add Staff"
                    handleSubmit={StaffSubmitHandler}
                    disable={selectedStaff.length === 0}
                    height="h-full"
                  />
                </ShadowContainer>
              </Card.AddPopUp>
            ) : (
              ""
            )}
            <div className="flex flex-wrap justify-center items-center w-full h-full">
              {deleteConfirmationPopup && (
                <Card.Confirmation
                  message="Are you sure you want to delete this store?"
                  onConfirm={() => DeleteHandler()}
                  onClose={handleDeleteConfirmationPopup}
                  loading={deleteStoreLoading}
                  loadingTitle="Deleting..."
                />
              )}
              <div className="flex flex-col  py-6 md:px-8 w-full h-full">
                <BackHeader
                  backButton={true}
                  link="/stores"
                  title="Store Details"
                  rightSide={
                    <div className="flex gap-5">
                      <BlackButton
                        title="Delete"
                        handleSubmit={handleDeleteConfirmationPopup}
                        backgroundColor="rgb(239 68 68)"
                      />
                      <button
                        type="submit"
                        className="bg-slate-500 text-white text-xs md:text-base px-2 md:px-4 py-2 rounded-md"
                        onClick={editStoreDetails}
                      >
                        Edit Details
                      </button>
                    </div>
                  }
                />

                <div className="h-[90%] overflow-scroll flex flex-col gap-5 mt-5">
                  <div className="py-2 px-7  rounded ">
                    <div className="mb-4 md:flex md:space-x-4">
                      <div className="flex-1">
                        <h3 className="block text-gray-700 font-semibold">
                          Store Name
                        </h3>
                        <p className="mt-1 p-2 bg-white rounded border border-slate-300">
                          {storeDetails?.storeDetails?.name || "-"}
                        </p>
                      </div>
                      <div className="flex-1">
                        <h3 className="block text-gray-700 font-semibold">
                          Email
                        </h3>
                        <p className="mt-1 p-2 bg-white rounded border border-slate-300">
                          {storeDetails?.storeDetails?.email || "-"}
                        </p>
                      </div>
                    </div>
                    <div className="mb-4">
                      {/* Phone and Store Code */}
                      <div className="flex flex-col md:flex-row md:gap-4">
                        <div className="flex-1">
                          <h3 className="block text-gray-700 font-semibold">
                            Phone
                          </h3>
                          <p className="mt-1 p-2 bg-white rounded border border-slate-300">
                            {storeDetails?.storeDetails?.phone || "-"}
                          </p>
                        </div>
                        <div className="flex-1">
                          <h3 className="block text-gray-700 font-semibold">
                            Store Code
                          </h3>
                          <p className="mt-1 p-2 bg-white rounded border border-slate-300">
                            {storeDetails?.storeCode || "-"}
                          </p>
                        </div>
                      </div>

                      {/* City and Address */}
                      <div className="flex flex-col md:flex-row md:gap-4 mt-4">
                        <div className="flex-1">
                          <p className="text-sm text-slate-500">City:</p>
                          <div className="w-full border bg-white border-slate-200 focus:outline-none px-4 py-2 mt-1 rounded-lg">
                            {storeDetails?.storeDetails?.addressDetails?.city ||
                              "N/A"}
                          </div>
                        </div>
                        <div className="flex-1">
                          <p className="text-sm text-slate-500">Address:</p>
                          <div className="w-full border bg-white border-slate-200 focus:outline-none px-4 py-2 mt-1 rounded-lg">
                            {storeDetails?.storeDetails?.addressDetails
                              ?.address || "N/A"}
                          </div>
                        </div>
                      </div>

                      {/* Zip Code */}
                      <div className="flex flex-col md:flex-row md:gap-4 mt-4">
                        <div className="flex-1">
                          <p className="text-sm text-slate-500">Zip Code:</p>
                          <div className="w-full border bg-white border-slate-200 focus:outline-none px-4 py-2 mt-1 rounded-lg">
                            {storeDetails?.storeDetails?.addressDetails?.zip ||
                              "N/A"}
                          </div>
                        </div>
                      </div>

                      {/* Country and Province */}
                      <div className="flex flex-col md:flex-row md:gap-4 mt-4">
                        <div className="flex-1">
                          <p className="text-sm text-slate-500">Country:</p>
                          <div className="w-full border bg-white border-slate-200 focus:outline-none px-4 py-2 mt-1 rounded-lg">
                            {storeDetails?.storeDetails?.addressDetails
                              ?.country || "N/A"}
                          </div>
                        </div>
                        <div className="flex-1">
                          <p className="text-sm text-slate-500">Province:</p>
                          <div className="w-full border bg-white border-slate-200 focus:outline-none px-4 py-2 mt-1 rounded-lg">
                            {storeDetails?.storeDetails?.addressDetails
                              ?.province || "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="py-2 px-7  rounded">
                    <div className="flex flex-col mt-2">
                      <div className="flex justify-between">
                        <p className="text-xl  text-slate-500 font-medium">
                          Manager Details :
                        </p>
                        <button
                          className="px-5 py-2  bg-slate-500 hover:bg-zinc-800 rounded-lg text-white"
                          // onClick={assignManagerPopup}
                          onClick={() => setShowPopUp("manager")}
                        >
                          Assign Manager
                        </button>
                      </div>
                      <div className="h-[1px] bg-slate-300 my-2"></div>

                      {/* <ShadowContainer
                    title="Assign Manager"
                    onClick={() => setShowPopUp("manager")}
                  > */}
                      {formdata.manager &&
                      Object.keys(formdata.manager).length > 0 ? (
                        <div className="flex flex-col shadow w-full rounded p-2">
                          <span>
                            {formdata.manager?.managerName ||
                              formdata.manager?.name}
                          </span>
                          <span>
                            {formdata.manager?.managerEmail ||
                              formdata.manager?.email}
                          </span>
                          <span>
                            {formdata.manager.managerPhone ||
                              formdata.manager?.phone}
                          </span>
                          {/* <span>{formdata.manager.status}</span>
                          <span>{formdata.manager.userType}</span> */}
                        </div>
                      ) : (
                        <div className="flex flex-col gap-5 justify-center align-middle items-center py-10">
                          <p className="text-slate-500 text-lg">
                            There are no details available
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="py-2 px-7  rounded ">
                    <div className="flex flex-col mt-2">
                      <div className="flex justify-between">
                        <p className="text-xl pb-2 text-slate-500 font-medium">
                          Staff Details :
                        </p>
                        <button
                          className="px-5 py-2  bg-slate-500 hover:bg-zinc-800 rounded-lg text-white"
                          // onClick={assignManagerPopup}
                          onClick={() => setShowPopUp("staff")}
                        >
                          Add Staff
                        </button>
                      </div>
                      <div className="h-[1px] bg-slate-300 my-2"></div>
                      {formdata.staff.length > 0 ? (
                        <div className="flex flex-col gap-3">
                          {formdata.staff.map((item, index) => (
                            <div
                              key={index}
                              className="shadow w-full group  rounded p-2 flex justify-between items-start"
                            >
                              <div className="flex flex-col w-full">
                                <span>Staff Id : {item.userId}</span>
                                <span>Name : {item.userName}</span>
                                <span>Email : {item.userEmail}</span>
                                <span>Phone : {item.userPhone}</span>
                                {/* <span>{item.status}</span>
                              <span>{item.userType}</span> */}
                              </div>
                              <div className="group-hover:block hidden cursor-pointer ">
                                <span
                                  className="bg-red-100 border-red-400 text-red-600 p-2 rounded flex"
                                  onClick={() =>
                                    handleRemoveStaff(item.userObjId)
                                  }
                                >
                                  <AiOutlineDelete />
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="flex justify-center  items-center py-10">
                          <p className="text-slate-500 text-lg">
                            There are no details available
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {showAssignManagerPopup && (
                <>
                  <div className="fixed top-0 left-0 w-full h-full opacity-30 bg-black"></div>
                  <div
                    className={`fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg w-11/12 md:w-[50rem] pl-6 pr-6 pt-8 pb-8 md:pl-8 md:pr-8 md:pt-10 md:pb-10`}
                  >
                    <div className="md:flex space-y-2 md:space-y-0  justify-between my-3 h-[10%] items-center">
                      <div className="">
                        <h2 className="text-2xl font-bold text-slate-500">
                          Select Manager
                        </h2>
                      </div>
                      <div className="flex gap-5 items-center">
                        {/* <div className="flex items-center px-3 rounded-full bg-white/100 border w-60 h-10">
                                            <FiSearch />
                                            <input
                                                type="text"
                                                placeholder="search Manager Name..."
                                                className="outline-none w-full px-2 bg-white/100"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                            />
                                        </div> */}
                        <SearchContainer
                          value={searchInput}
                          placeholder={"Search Manager Name"}
                          onChange={(e) => setSearchInput(e.target.value)}
                        />
                        <div>
                          {/* <button className="text-3xl md:text-4xl" onClick={assignManagerPopup}>&times;</button> */}
                          <div
                            className="flex items-center justify-center border border-slate-400 rounded-sm  md:rounded-md w-3 h-3 lg:w-4 lg:h-4 md:w-8 md:h-8 cursor-pointer"
                            onClick={assignManagerPopup}
                          >
                            <span className="text-slate-500 text-md md:text-xl">
                              &times;
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="h-[80%] overflow-hidden relative overflow-x-auto border-[1px] border-slate-200 sm:rounded-lg">
                      <table className="w-full text-sm text-left rtl:text-right text-gray-500  max-h-96">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-50   sticky top-0">
                          <tr className="border-b border-gray-200">
                            <th scope="col" className="px-6 py-3">
                              Name
                            </th>
                            <th scope="col" className="px-6 py-3">
                              Phone
                            </th>
                            <th scope="col" className="px-6 py-3">
                              Email
                            </th>
                            <th scope="col" className="px-6 py-3 text-center">
                              Select
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {managers &&
                            managers
                              .filter((user) =>
                                user.name
                                  .toLowerCase()
                                  .includes(searchInput.toLowerCase())
                              )
                              .map((item, index) => (
                                <tr
                                  key={index}
                                  className={`${
                                    index % 2 === 0
                                      ? "odd:bg-white"
                                      : "even:bg-gray-50 "
                                  } border-b`}
                                >
                                  <td className="px-6 py-4">{item?.name}</td>
                                  <td className="px-6 py-4">{item?.phone}</td>
                                  <td className="px-6 py-4">{item?.email}</td>
                                  <td className="px-6 py-4 text-center">
                                    <button
                                      className={`px-3 py-1 rounded text-sm ${
                                        selectedManager?._id === item._id
                                          ? "bg-slate-700 text-white"
                                          : "bg-slate-300 text-gray-700"
                                      }`}
                                      onClick={() => handleSelectUser(item)}
                                    >
                                      {selectedManager?._id === item._id
                                        ? "Selected"
                                        : "Select"}
                                    </button>
                                  </td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div> */}

                    <div className="text-center h-[10%]">
                      <button className="bg-slate-500 text-white px-20 py-2 rounded-md mt-4">
                        Assign
                      </button>
                    </div>
                  </div>
                  <div></div>
                </>
              )}
            </div>
          </>
        )}
      </Container>
    </Layout>
  );
}

export default StoreDetails;
